//** Component  */
import React from 'react';

const ValidationText = (props) => {
    return (
        props.error ?
            <div className="text-xs mt-1 text-danger">{props.error}</div>
            : null
    )
}

export default ValidationText;
